import { Alert } from "@svea/design-system-components-react";
import { P, SimpleGrid, Stack, useText } from "@sveabank/cc-common";
import { useApplicationDetails } from "../../hooks/application";
import { usePageContext } from "../../hooks/context";
import { usePackage } from "../../hooks/package";
import type { DisplayedAddon, OnboardingAddon } from "../../types/product";
import AddonItem from "./addon-item";
import { isCreditWorthy } from "./helpers";
import { useChoosePackage } from "./hooks";

const filterDisplayedAddons = (a: OnboardingAddon): a is DisplayedAddon =>
	a.definitionId === "CHECKKREDIT" ||
	a.definitionId === "CREDITCARD" ||
	a.definitionId === "DEBITCARD";

const ChooseAddons = () => {
	const [t, texts] = useText();
	const { creditScore } = usePageContext(useChoosePackage);
	const { selectedPackage } = usePackage();
	const { applicationDetails } = useApplicationDetails();

	const interestPromotion = applicationDetails?.promotions.find(
		(p) => p.promotionType === "interestRateDiscount",
	);

	const isRejected = !creditScore?.assessment || !isCreditWorthy(creditScore.assessment);

	const hasCheckCredit = selectedPackage?.products.find((p) => p.definitionId === "CHECKKREDIT");

	const addons =
		isRejected && selectedPackage?.addons
			? selectedPackage.addons.filter(
					(a) => a.definitionId !== "CREDITCARD" && a.definitionId !== "CHECKKREDIT",
				)
			: selectedPackage?.addons;

	const displayedAddons = addons?.filter(filterDisplayedAddons);

	return (
		displayedAddons && (
			<div data-testid="choose-addons" id="choose-addons">
				<Stack gap={4}>
					<P>{t(texts.chooseAddons.description)}</P>

					{!isRejected && !hasCheckCredit && !interestPromotion && (
						<Alert kind="information" title="Få tillgång till kapital mot låg månadskostnad">
							Jämna ut kassaflödet genom att lägga till kontokredit. Du får en{" "}
							<strong>
								förmånlig månadsränta på {creditScore.assessment?.check.monthlyInterestRate} %
							</strong>{" "}
							på krediten du använder.
						</Alert>
					)}

					<SimpleGrid cols={3}>
						{displayedAddons.map((addon) => (
							<AddonItem key={addon.definitionId} addon={addon} />
						))}
					</SimpleGrid>
				</Stack>
			</div>
		)
	);
};

export default ChooseAddons;
